<template>
  <cg-input
    :label="labelBalance"
    form-name="amount"
    @cg-input="changeBalance"
    type="number"
    step="0.01"
    :max="paymentMaxValue"
    required
  ></cg-input>

  <cg-input :label="labelDescription" form-name="description" type="text" required></cg-input>
  <cg-check
    :disabled="paymentDisabled"
    :label="labelPayment"
    form-name="payment"
    :info="paymentInfo"
    @cg-input="changePayment"
  ></cg-check>
  <cg-check
    @cg-input="changeFiscal"
    :disabled="!isAdmin"
    :label="labelFiscal"
    form-name="fiscal"
    :value="!isAdmin"
  ></cg-check>
  <cg-check :disabled="sendInvoiceDisabled" :label="labelSendInvoice" form-name="send-invoice"></cg-check>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps([
  'labelBalance',
  'labelDescription',
  'labelPayment',
  'labelFiscal',
  'labelSendInvoice',
  'threshold',
  'hasToken',
  'underThreshold',
  'topUpAmount',
  'isAdmin',
]);

const paymentInfoMessageDisabled =
  '<em>Charging credit card can only be made when the balance is less than balance for automatic payment, ' +
  'customer has valid payment token and balance change is positive</em>';

const paymentInfoMessageEnabled =
  `<em>Max value that can be charged is auto top up value for customer: ${props.topUpAmount.toFixed(2)}</em><br />` +
  '<strong class="text-danger">Use with extreme caution!!!</strong>';

const paymentDisabled = ref(true);
const sendInvoiceDisabled = ref(!!props.isAdmin);
const paymentInfo = ref(paymentInfoMessageDisabled);
const paymentMaxValue = ref(null);

function changeBalance(value) {
  paymentDisabled.value = isPaymentDisabled(value);
  paymentInfo.value = isPaymentDisabled(value) ? paymentInfoMessageDisabled : paymentInfoMessageEnabled;
}

function changePayment(value) {
  paymentMaxValue.value = value ? props.topUpAmount : null;
}

function changeFiscal(value) {
  sendInvoiceDisabled.value = !value;
  if (!value) {
    $('#send-invoice').prop('checked', false);
  }
}

function isPaymentDisabled(value) {
  return !props.hasToken || !props.underThreshold || value <= 0;
}
</script>
